import { GridRowModel } from '@mui/x-data-grid-pro';
import { useQuery } from '@tanstack/react-query';

import { ProdutoPedidoProps } from '../types';

import { useListagemContext } from 'context/ListagemContext';
import { useRequestListagem } from 'hooks/useRequestListagem';

export function useQueryProdutos({ row }: { row: GridRowModel }) {
    const { limit, page, sort, filter } = useListagemContext();
    const requestListagem = useRequestListagem();

    return useQuery<ProdutoPedidoProps[]>({
        queryKey: ['carrinho-produtos', row.idPedido, page, limit, sort, filter],
        queryFn: () =>
            requestListagem({
                url: `/compra/pedidoprodutowrapper/rascunho/itens?idPedido=${row.idPedido}`,
                sort: sort.length ? sort : [[{ property: 'dsSubgrupo', direction: 'ASC' }]],
                page,
                filter,
                limit,
            }).then((res) => res.data),
    });
}
